import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { structuralMaterials } from '../data/mockData';
import { Check } from 'phosphor-react';

export const MaterialSelector = ({ selected, onSelect }) => {
  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-slate-100 mb-2">Structural Material</h3>
        <p className="text-sm text-slate-400">Choose the primary construction material</p>
      </div>

      <div className="space-y-3">
        {structuralMaterials.map((material) => (
          <Card 
            key={material.id}
            className={`cursor-pointer transition-all duration-200 hover:shadow-lg ${
              selected === material.id 
                ? 'ring-2 ring-blue-500 bg-slate-700 border-blue-500' 
                : 'border-slate-600 bg-slate-750 hover:border-blue-400 hover:bg-slate-700'
            }`}
            onClick={() => onSelect(material.id)}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold text-lg"
                    style={{ backgroundColor: material.color }}
                  >
                    {material.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-200">{material.name}</h4>
                  </div>
                </div>
                {selected === material.id && (
                  <div className="flex items-center gap-2">
                    <Badge className="bg-blue-600 text-white">Selected</Badge>
                    <Check className="w-5 h-5 text-blue-400" />
                  </div>
                )}
              </div>
              
              {/* Material Properties */}
              <div className="grid grid-cols-3 gap-2 mt-3">
                <div className="text-center">
                  <p className="text-xs text-slate-400">Strength</p>
                  <p className="text-sm font-medium text-slate-200">{material.properties.strength}</p>
                </div>
                <div className="text-center">
                  <p className="text-xs text-slate-400">Weight</p>
                  <p className="text-sm font-medium text-slate-200">{material.properties.weight}</p>
                </div>
                <div className="text-center">
                  <p className="text-xs text-slate-400">Cost</p>
                  <p className="text-sm font-medium text-slate-200">{material.properties.cost}</p>
                </div>
              </div>

              {/* Material Sample */}
              <div className="mt-3">
                <div 
                  className="w-full h-3 rounded-md border border-slate-500"
                  style={{ backgroundColor: material.color }}
                ></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Selection Actions */}
      <div className="pt-4 border-t border-slate-600">
        <Button 
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          disabled={!selected}
        >
          Apply Material
        </Button>
      </div>
    </div>
  );
};